module.exports = __webpack_public_path__ + "static/media/94.5956ca80.wav";